module.exports = __webpack_public_path__ + "img/02_4_5_2.5f4d1903.png";